// Yeni Kurye Ekle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'couriers.addCourier';

export const addCourierGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kurye nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Kayıtlı personelinizden bir veya birkaç kişiyi kurye yaparsınız. Yeni bir kişi oluşturulmaz; seçtiğiniz personel kurye olarak işaretlenir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Personel seçimi ve kurye yetkileri'),
    footer: t(`${G}.regions.footer`, 'İptal / Kuryeyi Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Personeli seçin'),
      text: t(`${G}.s1.text`, '"Personel ara..." kutusuna ad, e-posta veya telefon yazarak listeyi daraltın. Kurye yapmak istediğiniz kişilerin yanındaki kutuyu işaretleyin; birden fazla kişi seçebilirsiniz. Seçilenler altta "Seçili Personeller" bölümünde görünür; bir kişiyi çıkarmak için adının yanındaki çarpıya basın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Listede yalnız çalışan rolündeki personel görünür; yönetici ve şube müdürleri ile zaten kurye olanlar listelenmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kurye yetkilerini kontrol edin'),
      text: t(`${G}.s2.text`, 'Seçtiğiniz her kişide tüm kurye uygulaması yetkileri açık gelir. Değiştirmek için kişinin satırındaki "Yetkileri Düzenle" düğmesine basın; altta "Kurye Yetkileri" bölümü açılır ve her yetkiyi anahtarla açıp kapatırsınız.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yetkiler: Kurye Uygulamasına Erişim, Atanan Siparişleri Görme, Sipariş Durumunu Güncelleme, Müşteri Bilgilerini Görme, Müşteriyi Arama, Sipariş Detaylarını Görme, Teslim Edildi İşaretleme, Sorun Bildirme, Kazançları Görme.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Kaydedin'),
      text: t(`${G}.s3.text`, '"Kuryeyi Kaydet" seçtiğiniz herkesi tek seferde kurye yapar. Başarı mesajından birkaç saniye sonra pencere kapanır ve kurye listesi yenilenir. "İptal" hiçbir değişiklik yapmadan kapatır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kaydettiğinizde personelin rolü "kurye" olarak değişir ve seçtiğiniz yetkiler kaydedilir.'),
        t(`${G}.s3.tip2`, 'Kurye, personelin kendi şubesine bağlanır; restoran ve e-ticaret siparişleri açık başlar. Bunları sonradan Kurye Yönetimi\'ndeki "Sipariş Ayarları" ile değiştirebilirsiniz.'),
      ],
    },
  ],
});
